import { type Dispatch } from "@reduxjs/toolkit";
import { type AppThunk } from "features/Application/globaltypes/redux";
import integrationsDataService from "../../../services/integrationsDataService";
import { fetchBegin, fetchFailure, fetchSuccess, triggerSync } from "../slices/integrationsOverviewSlice";

export const triggerMsGraphSync =
  (id: number, type: string): AppThunk =>
  async (dispatch, _) => {
    try {
      await integrationsDataService.triggerMsSync(`${id}`);
      dispatch(triggerSync({ id, type }));
    } catch {}
  };

export const fetchIntegrationsAction = (moboId?: string) => async (dispatch: Dispatch) => {
  dispatch(fetchBegin());
  try {
    const result = await integrationsDataService.getIntegrationSettings(moboId);
    dispatch(fetchSuccess({ items: result, totalCount: result.length }));
  } catch (error) {
    dispatch(fetchFailure(error as Error));
  }
};
